var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ArtisanGrid',{ref:"notes",attrs:{"metaKey":"ZlNotesInfo"},scopedSlots:_vm._u([{key:"leftAside",fn:function(){return [_c('artisan-group',{staticStyle:{"height":"100%","border":"none","overflow-y":"auto"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }